import Vue from 'vue'
import Vuex from 'vuex'
import VuexPersistence from 'vuex-persist'

Vue.use(Vuex)

export default new Vuex.Store({
  state: {
    player: {
      data: null,
      warehouse: null,
      buildings: null
    },
    simsession: null,
    resources: null,
  },
  mutations: {
    updateSimsession (state, simsession) {
      state.simsession = simsession
    },
    updatePlayer (state, player) {
      state.player.data = player
    },
    updateWarehouse (state, warehouse) {
      state.player.warehouse = warehouse
    },
    updateResources (state, resources) {
      state.resources = resources
    }
  },
  actions: {
  },
  modules: {},
  plugins: [new VuexPersistence().plugin]
})
